import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79574530"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "booking-extras" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BookingHeader = _resolveComponent("BookingHeader")!
  const _component_BaseSpinner = _resolveComponent("BaseSpinner")!
  const _component_BaseAlert = _resolveComponent("BaseAlert")!
  const _component_BookingExtra = _resolveComponent("BookingExtra")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BookingHeader, {
      title: _ctx.$t('extras.title'),
      subtitle: _ctx.$t('extras.subtitle')
    }, null, 8, ["title", "subtitle"]),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_BaseSpinner, {
          key: 0,
          size: 50
        }))
      : (_ctx.error)
        ? (_openBlock(), _createBlock(_component_BaseAlert, {
            key: 1,
            message: _ctx.error,
            type: "danger"
          }, null, 8, ["message"]))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.components, (component, index) => {
            return (_openBlock(), _createBlock(_component_BookingExtra, {
              key: index,
              componentIndex: index,
              component: component
            }, null, 8, ["componentIndex", "component"]))
          }), 128))
  ]))
}